// App.jsx
import { Container, useMediaQuery, GlobalStyles } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";

import CookieConsentBanner from "./components/shared/CookieConsentBanner.jsx";
import Footer from "./components/shared/Footer";
import Header from "./components/shared/Header";

import i18n from "./i18n";
import theme from "./themes/theme";
import { getModalityFromHostname } from "./services/Utils.js";

import "./styles/global.css";

import FormRouter from "./routes/index.jsx";

function App() {
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const filteredParams = {
    tos: searchParams.get("tos"),
    ua: searchParams.get("ua"),
    trv: searchParams.get("trv"),
    surveyID: searchParams.get("surveyID"),
    caseID: searchParams.get("caseID"),
  };

  const modality = getModalityFromHostname(window?.location?.hostname);
  const interactionIdKey = location.pathname.split("/")[2] || undefined;

  useEffect(() => {
    // Clear local storage on load to reset Genesys
    window.localStorage.clear();
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CookieConsentBanner />
        <I18nextProvider i18n={i18n}>
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: isDesktop
                  ? theme.palette.plum100
                  : theme.palette.white,
              },
            }}
          />
          <Header />

          <Container
            maxWidth="md"
            disableGutters
            sx={{ bgcolor: theme.palette.white, borderRadius: "10px" }}
          >
            <Container
              maxWidth="md"
              disableGutters
              sx={{
                mt: isDesktop ? 6 : 2,
                pt: isDesktop ? 1 : 0,
                mb: isDesktop ? 13 : 0,
                pb: 1.5,
                px: 1.5,
                bgcolor: "transparent",
              }}
            >
              <FormRouter
                modality={modality}
                interactionIdKey={interactionIdKey}
                filteredParams={filteredParams}
              />
            </Container>
          </Container>
          <Footer />
        </I18nextProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
